import { Component, HostBinding, input } from '@angular/core'

@Component({
  standalone: true,
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent {
  protected starSize = input<'small' | 'regular'>('regular')
  protected color = input<string>('yellow')

  @HostBinding('style.--star-color')
  get bgColor(): string {
    return `var(--color-${this.color()})`
  }
}
